import React from "react";
import { Box, Typography } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import classes from "./Filter.module.css";
import PropTypes from "prop-types";

const FilterElement = ({
  FilterLabel,
  onClick = () => {},
  isDateIconClicked,
  isStatusIconClicked,
}) => {
  return (
    <Box className={classes["filter-element-main-container"]}>
      <Typography sx={{ fontSize: "1.4rem" }}>{FilterLabel}</Typography>
      {isDateIconClicked || isStatusIconClicked ? (
        <ExpandLess
          fontSize="large"
          sx={{ cursor: "pointer" }}
          onClick={onClick}
        />
      ) : (
        <ExpandMore
          fontSize="large"
          sx={{ cursor: "pointer" }}
          onClick={onClick}
        />
      )}
    </Box>
  );
};

FilterElement.prototypes = {
  FilterLabel: PropTypes.string,
  onClick: PropTypes.func,
  isDateIconClicked: PropTypes.bool,
  isStatusIconClicked: PropTypes.bool,
};

export default FilterElement;
